<template>
  <div
    class="w-full border-t border-b border-[#fa683a]/30 _main px-5 flex flex-col justify-center py-2"
  >
    <div class="text-sm text-[#FA683A] opacity-60 flex items-center">
      返回值
      <a-tooltip v-if="showTooltip">
        <icon icon="help.svg" :width="14" :height="14" fill="none" />
        <template #title>
          <template v-if="sourceItem?.key == 'systemSensorCompassDirection'">
            <div class="p-2">
              <div class="mb-2">方向和角度对照关系：</div>
              <div
                v-for="item in getCompassDirectionsArr()"
                :key="item.value"
                class="flex gap-2 !gap-y-4 opacity-75"
              >
                <div class="flex-1">{{ item.desc }}</div>
                <div class="w-[30px]">{{ item.label }}</div>
              </div>
            </div>
          </template>
        </template>
      </a-tooltip>
    </div>
    <div class="mt-1 text-base text-[#FA683A] opacity-90">
      {{ returnValue }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { getCompassDirectionsArr } from '@/hooks/use-image-array';
import { PropType, computed } from 'vue';

const props = defineProps({
  sourceItem: {
    type: Object as PropType<DataSourceItem>,
    default: undefined
  }
});

const returnValue = computed(() => {
  const _value = (sourceItem: DataSourceItem) => {
    if (sourceItem?.returnValue) {
      return sourceItem.returnValue;
    } else if (
      sourceItem?.minValue !== undefined &&
      sourceItem?.maxValue !== undefined
    ) {
      return `[${sourceItem?.minValue}, ${sourceItem?.maxValue}]`;
    } else {
      return sourceItem?.comment;
    }
  };
  const sourceItem = props.sourceItem;
  return sourceItem ? _value(sourceItem) : '-';
});

const showTooltip = computed(() => {
  const sourceItem = props.sourceItem;
  return sourceItem?.key == 'systemSensorCompassDirection';
});
</script>

<style lang="less" scoped>
._main {
  background: #362723;
}
</style>
